import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { MODAL_TYPE_PDF_VIEW_IMAGE } from '../../../../actions/ModalActions';
import { propArrayShape, propChildren, propNumber, propOneOfType, propShape, propStrList, } from '../../../../helpers/custom-prop-types';
import { getModalValue } from '../../../../helpers/modal';
import PdfImageModalThumbnailSlider from './PdfImageModalThumbnailSlider';
const PdfImageModalContent = (props) => {
    const { customChildren, dataAttributes, images, initialSlide, pdfProp } = props;
    if (images.length === 0) {
        return null;
    }
    return (_jsx(PdfImageModalThumbnailSlider, { customChildren: customChildren, dataAttributes: dataAttributes, images: images, initialSlide: initialSlide, pdfProp: pdfProp }));
};
PdfImageModalContent.propTypes = {
    customChildren: propChildren(),
    dataAttributes: propShape(),
    images: propOneOfType([propStrList(), propArrayShape()]),
    initialSlide: propNumber(),
    pdfProp: propShape(),
};
PdfImageModalContent.defaultProps = {
    customChildren: undefined,
    dataAttributes: {},
    images: [],
    initialSlide: 0,
    pdfProp: {},
};
const mapStateToProps = ({ modal }) => {
    const { item } = getModalValue(modal, MODAL_TYPE_PDF_VIEW_IMAGE);
    return item;
};
const enhance = compose(connect(mapStateToProps));
export default enhance(PdfImageModalContent);
